module.exports = __webpack_public_path__ + "img/cw.20f8c8bc.svg";